import { render, staticRenderFns } from "./TopRightFloatingPanel.vue?vue&type=template&id=36f153a0&scoped=true&"
import script from "./TopRightFloatingPanel.vue?vue&type=script&lang=js&"
export * from "./TopRightFloatingPanel.vue?vue&type=script&lang=js&"
import style0 from "./TopRightFloatingPanel.vue?vue&type=style&index=0&id=36f153a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f153a0",
  null
  
)

export default component.exports